<template>
    <div :class="[$store.state.hftype==1?'header':'header2', 'modulewrap']">
        <div class="langbarwrap">
            <div :class="['langbar',{'maxscreen':$store.state.hftype==1}]"><a href="#" @click="setlangcur(1)" :class="{cs:$store.state.langcur == 1}">中文</a><span>|</span><a href="#" @click="setlangcur(2)" :class="{cs:$store.state.langcur != 1}">EN</a></div>
        </div>
        <div class="topbarwrap">
            <div :class="['topbar',{'maxscreen':$store.state.hftype==1}]">
                <div class="logo"><router-link to="/"><img :src="$store.state.logourl" /></router-link><img v-if="schoollogo" :src="schoollogo" /></div>
                <div class="toptitle" v-if="$store.state.toptitle"><a href="">{{$store.state.toptitle}}</a></div>
                <div class="nav">
                    <ul>
                        <li v-if="$store.state.hftype==1">
                            <a href="/">{{$common.dicword('homepage')}}</a>
                        </li>
                        <li v-if="$store.state.hftype==1">
                            <a href="#" @click="showabout">{{$common.langinfo(infodata.title,infodata.title_en)}}</a>
                        </li>
                        <li v-if="islogin" @mouseover="me.showmore=true" @mouseout="me.showmore=false">
                            <router-link to="/member" class="me"><img :src="$common.getface($store.state.face)" /><br />{{$common.basic.strgetlen($store.state.showname, 8)}}</router-link>
                            <transition name="fade">
                                <div class="navmore menav" v-show="me.showmore">
                                    <dl>
                                        <dd class="mem" v-for="item in mynav" :key="item.id">

                                            <a href="#" @click="showcourseoption" v-if="item.kv==2"><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</a>
                                            <router-link :to="item.url" v-else><i :class="['iconfont',item.icon]"></i>{{$common.langinfo(item.title,item.title_en)}}</router-link>
                                        </dd>
                                        <dd class="mem"><a href="#" @click="$common.logout"><i class="iconfont icon-tuichudenglute"></i>{{$common.dicword('logout')}}</a></dd>
                                    </dl>
                                </div>
                            </transition>
                        </li>
                        <li v-else><a href="#" @click="showlogin(1)">{{$common.dicword('login')}}</a><span>|</span><a href="#" @click="showlogin(3)">{{$common.dicword('reg')}}</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="isshowcourseoption" top="0px">
            <div class="courseoption">
                <dl>
                    <dd><a href="#" @click="isshowcourseoption=false,$router.push('/course')"><img src="/images/tol.jpg" /><br />{{$common.dicword('olr')}}</a></dd>
                    <dd v-if="hastdl"><a href="#" @click="isshowcourseoption=false,$router.push('/tdl')"><img src="/images/tdl.jpg" /><br />{{$common.dicword('tdl')}}</a></dd>
                    <dd v-if="hastsr"><a href="#" @click="isshowcourseoption=false,$router.push('/tsr')"><img src="/images/tsr.jpg" /><br />{{$common.dicword('tsr')}}</a></dd>
                </dl>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: 'Cheader',
        data() {
            return {
                infodata: {},
                islogin: false,
                me: {},
                mynav: [],
                isshowcourseoption: false,
                hastdl: false,
                hastsr: false,
                schoollogo: ''
            };
        },
        methods: {
            setlangcur: function (v) {
                this.$store.commit('SET_LANGCUR', v);
                return false;
            },
            showlogin: function (v) {
                this.$emit('showlogin', v);
            },
            logout: function () {
                this.$common.logout();
            },
            showcourseoption: function () {
                this.me.showmore = false;

                let jsondata = { 'postdata': { 'act': 'te_course_option' }, 'msg': '' };
                this.$common.post(jsondata, res => {
                    this.hastdl = res.hastdl;
                    this.hastsr = res.hastsr;

                    if (this.hastdl || this.hastsr) {
                        this.isshowcourseoption = true;
                    }
                    else {
                        this.$router.push('/course');
                    }
                });

            },
            showabout: function () {
                window.showabout(this.infodata.id);

            }
        },
        mounted() {
            let jsondata = { 'postdata': { 'act': 'te_header' }, 'msg': '' };
            this.$common.post(jsondata, res => {
                this.$store.dispatch('setlogourl', res.infodataimg.imgs);//异步设置logo
                this.infodata = res.infodata;
                this.islogin = res.islogin == 1;
                if (this.islogin) {
                    this.$store.dispatch('setusername', res.infodatame.username);
                    this.$store.dispatch('setshowname', res.infodatame.showname || res.infodatame.realname || res.infodatame.username);
                    this.$store.dispatch('setface', res.infodatame.face);
                    this.$store.dispatch('setmemlev', res.infodatame.lev);
                    res.infodatame.showmore = false;
                    this.me = res.infodatame;
                    this.mynav = res.infodatanav;
                    this.schoollogo = this.$common.basic.mydecode(res.schoollogo);

                }

            });

            let vm = this;
            window.showcourseoption = function () {
                vm.showcourseoption();
            };
        }
    };
</script>
